
import { WorldCountry } from '../types';

export const peruData: WorldCountry = {
  code: 'PE',
  name: 'Peru',
  slug: 'peru',
  population: 32971854,
  topCities: [
    { name: 'Lima', slug: 'lima', population: 10092000 },
    { name: 'Arequipa', slug: 'arequipa', population: 1080635 },
    { name: 'Trujillo', slug: 'trujillo-pe', population: 919899 },
    { name: 'Chiclayo', slug: 'chiclayo', population: 596012 },
    { name: 'Piura', slug: 'piura', population: 484475 },
    { name: 'Iquitos', slug: 'iquitos', population: 471993 },
    { name: 'Cusco', slug: 'cusco', population: 428450 },
    { name: 'Chimbote', slug: 'chimbote', population: 371012 },
    { name: 'Huancayo', slug: 'huancayo', population: 364725 },
    { name: 'Tacna', slug: 'tacna', population: 326240 },
    { name: 'Juliaca', slug: 'juliaca', population: 307417 },
    { name: 'Ica', slug: 'ica', population: 282407 },
    { name: 'Sullana', slug: 'sullana', population: 228020 },
    { name: 'Ayacucho', slug: 'ayacucho', population: 220609 },
    { name: 'Chincha Alta', slug: 'chincha-alta', population: 177219 },
    { name: 'Huánuco', slug: 'huanuco', population: 196627 },
    { name: 'Pucallpa', slug: 'pucallpa', population: 326040 },
    { name: 'Tarapoto', slug: 'tarapoto', population: 165458 },
    { name: 'Puno', slug: 'puno', population: 140839 },
    { name: 'Tumbes', slug: 'tumbes', population: 111595 },
    { name: 'Talara', slug: 'talara', population: 103200 },
    { name: 'Jaén', slug: 'jaen-pe', population: 97026 },
    { name: 'Huaraz', slug: 'huaraz', population: 127041 },
    { name: 'Moquegua', slug: 'moquegua', population: 74863 },
    { name: 'Abancay', slug: 'abancay', population: 72277 },
    { name: 'Cerro de Pasco', slug: 'cerro-de-pasco', population: 70914 },
    { name: 'Moyobamba', slug: 'moyobamba', population: 74061 },
    { name: 'Bagua Grande', slug: 'bagua-grande', population: 62690 },
    { name: 'Chachapoyas', slug: 'chachapoyas', population: 32026 },
    { name: 'Huacho', slug: 'huacho', population: 61908 },
    { name: 'Barranca', slug: 'barranca', population: 62694 },
    { name: 'Casma', slug: 'casma', population: 32144 },
    { name: 'Huarmey', slug: 'huarmey', population: 29141 },
    { name: 'Chepén', slug: 'chepen', population: 50625 },
    { name: 'Pacasmayo', slug: 'pacasmayo', population: 26118 },
    { name: 'Guadalupe', slug: 'guadalupe-pe', population: 43009 },
    { name: 'Casa Grande', slug: 'casa-grande', population: 35042 },
    { name: 'Lambayeque', slug: 'lambayeque', population: 63386 },
    { name: 'Ferreñafe', slug: 'ferrenafe', population: 35847 },
    { name: 'Monsefú', slug: 'monsefu', population: 30123 },
    { name: 'Olmos', slug: 'olmos', population: 36853 },
    { name: 'Motupe', slug: 'motupe', population: 17516 },
    { name: 'Salas', slug: 'salas', population: 14129 },
    { name: 'Incahuasi', slug: 'incahuasi', population: 18617 },
    { name: 'Cañete', slug: 'canete', population: 43254 },
    { name: 'San Vicente de Cañete', slug: 'san-vicente-de-canete', population: 58678 },
    { name: 'Imperial', slug: 'imperial', population: 37879 },
    { name: 'Mala', slug: 'mala', population: 27881 },
    { name: 'Asia', slug: 'asia-pe', population: 8274 },
    { name: 'Lunahuaná', slug: 'lunahuana', population: 4378 }
  ]
};
